<template>
  <div class="documentation">
    <div class="row">
      <div class="col-md-5">
        <Breadcumb title="Inviter un utilisateur" :breadcumb-data="breadcumbData"></Breadcumb>
      </div>
    </div>
    <b-card class="cardcontainer">
      <b-form @submit="addUser">
  
        <span style="color:#ff0000" v-if="error">{{ error }}</span>
        <b-form-group label="Nom" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          
          <b-input type="text" placeholder="Nom" v-model="lastname"/>
          <b-alert  v-if="errors['lastname']" show variant="danger">
            {{ errors['lastname'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Prénom" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Prénom" v-model="firstname"/>
          <b-alert  v-if="errors['firstname']" show variant="danger">
            {{ errors['firstname'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Email" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Email" v-model="email"/>
          <b-alert  v-if="errors['email']" show variant="danger">
            {{ errors['email'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-group label="Périmètre" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <v-jstree
                  :data="treeData"
                  :item-events="companies"
                  :class="{ 'tree-rtl': isRTL }"
                  show-checkbox
                  multiple
                  allow-batch
                  whole-row
                  draggable/>
        </b-form-group>
        <b-form-group label="Type d'utilisateur" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-select plain v-model="user_type_id" :options="userTypeData"/>
          <b-alert  v-if="errors['user_type_id']" show variant="danger">
            {{ errors['user_type_id'][0] }}
          </b-alert>
        </b-form-group>
        <b-form-row>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Inviter l'utilisateur</b-btn>
          </div>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
  import { ADMIN_GET_USERTYPES_REQUEST} from '../../_store/administration/user/actiontypes'
  import {GET_COMPANIES_REQUEST, GET_HIERARCHICAL_COMPANIES_REQUEST} from '../../_store/company/actiontypes';
  import {INVITE_USER_REQUEST, USER_REQUEST} from '../../_store/user/actiontypes';
  import Breadcumb from '../../components/breadcumb';
  import { mapState } from 'vuex';
  import VJstree from 'vue-jstree'
  
  
  function getChildrens(company) {
    return company.companies.map(children => {
      if (children.companies.length > 0){
        return {
          'show-checkbox': false,
          'text': children.name,
          'id': children.id,
          'selected': false,
          'children': getChildrens(children),
          'opened': false,
        }
      }
      else {
        return {
          'show-checkbox': false,
          'text': children.name,
          'id': children.id,
          'selected': false,
          'children': [],
          'opened': false,
        }
      }
    })
  }
  
  export default {
    name: 'adminCategoryAdd',
    components: {Breadcumb, VJstree},
    mounted() {
      this.$store.dispatch(USER_REQUEST)
              .then(response => {
                let user = response.data.user;
                this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
                        .then(response => {
                          let userTypes = response.data.usertypes.map(userType => {
                            if (user.userprofile.user_type.position < userType.position && userType.position <= 4){
                              if (this.$cookie.get('language') === 'fr') {
                                return {
                                  value: userType.id,
                                  text: userType.label
                                };
                              }
                              else{
                                return {
                                  value: userType.id,
                                  text: userType.label_en
                                };
                              }
                            }
                          });
                          this.userTypeData = userTypes.filter(userType => {
                            return userType !== null && userType !== undefined;
                          })
                        });
              })
      this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
        .then(response => {
            this.treeData = response.data.hierarchical_companies.map(company => {
              let childrens = [];
              if (company.companies.length > 0){
                childrens = getChildrens(company)
              }
              return {
                'show-checkbox': true,
                'text': company.name,
                'id': company.id,
                'children': childrens,
                'opened': false,
              }
            });
        });
    },
    computed: mapState({ errors: state => state.admin_user.errors }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des utilisateurs', href: '/dashboard/administration/userlist/'},
          { text: 'Inviter un utilisateur', active: true},

        ],
        companyData: [],
        companies: {},
        userTypeData: [],
        user_type_id: 0,
        company_id: 0,
        email: '',
        error: false,
        treeData: [],
        lastname: '',
        firstname: ''
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      addUser: function (e) {
        e.preventDefault();
        console.log("COMPANIES SELECTED");
        console.log(this.companies);
        console.log(this.treeData);
        this.$store.dispatch(INVITE_USER_REQUEST, {
          lastname: this.lastname,
          firstname: this.firstname,
          email: this.email,
          companies: this.treeData,
          user_type_id: this.user_type_id
        })
          .then(() => {
            this.$router.push('/dashboard/administration/userlist/');
          })
          .catch((error) => {
            if (error.error.user === 'noperimeter') {
              this.error = this.$t('noperimeter')
            } else if (error.error.email === 'duplicate'){
              this.error = this.$t('duplicate_email')
            }
          });
      }
    }
  };
</script>
